import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { navigate } from '@reach/router';
import { I18NConsumer } from 'commons';
import { baseUrl, orgId, Ajax, setPageTitle, getUrlParams } from 'utils';
import UpLogin from "./eb-login/UpLoginDiv";
import {GlobalContext} from "../../commons";


export default function Login(props) {
  const [loginMessage, setLoginMessage] = useState('');
  const { flags, universalProfileAuthUrl } = useContext(GlobalContext);

  const { children, enabledSSO, orgName, accountId } = props;
  const showUpLogin = flags?.PUBLIC_PORTAL_SHOW_LOGIN_TO_UP;

  const fetchLoginMessage = () => Ajax.get(`/index/homePage?orgId=${orgId}`);

  if (accountId) {
    const redirectUrl = `${baseUrl}/manage/${orgId}/${accountId}#/home`;
    window.location.href = redirectUrl;
  }

  useEffect(() => {
    fetchLoginMessage()
      .then(({ data }) => {
        const { homePage } = data;
        if (homePage) {
          const { pageContent } = homePage;
          setLoginMessage(pageContent);
        }
      })
      .catch(err => {
        console.error('error:', err);
      });
  }, []);

  useEffect(() => {
    const params = window.location.search;
    if (enabledSSO) {
      navigate(`/${orgId}/login/sso${params}`);
    } else if (/.*\/sso\/?$/.test(window.location.pathname)) {
      navigate(`/${orgId}/login${params}`);
    }
  }, []);

  return (
    <div className="login-view container">
      <I18NConsumer>
        {(i18n) => setPageTitle(`${orgName} - ${i18n['ssp.login.login']}`)}
      </I18NConsumer>
      {
        loginMessage && <div className="login-message-box" dangerouslySetInnerHTML={{ __html: loginMessage }} />
      }
      {
         showUpLogin && <UpLogin publicPortalURL={universalProfileAuthUrl} />
      }
      <div className="login-form-container">
        {
          children
        }
      </div>
    </div>
  );
}

Login.propTypes = {
  children: PropTypes.node.isRequired,
  enabledSSO: PropTypes.bool.isRequired,
  orgName: PropTypes.string.isRequired,
  accountId: PropTypes.string,
};

Login.defaultProps = {
  accountId: null
};
